// src/components/ContactModal/ContactModal.js
import React, { useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { functions } from '../../firebase'; // We'll update this file next
import './ContactModal.css';

const ContactModal = ({ onClose }) => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState('idle'); // idle, sending, success, error
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    setErrorMessage('');

    const sendContactEmail = httpsCallable(functions, 'sendContactEmail');
    try {
      await sendContactEmail(formData);
      setStatus('success');
    } catch (error) {
      console.error("Firebase function error:", error);
      setErrorMessage('Sorry, an error occurred. Please try again later.');
      setStatus('error');
    }
  };

  return (
    <div className="contact-overlay" onClick={onClose}>
      <div className="contact-panel" onClick={(e) => e.stopPropagation()}>
        <div className="contact-header">
          <h2>Contact Us</h2>
          <button onClick={onClose} className="contact-close-btn">&times;</button>
        </div>

        {status !== 'success' && (
          <form className="contact-form" onSubmit={handleSubmit}>
            <p>Have an event suggestion or feedback? Let us know!</p>
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label htmlFor="message">Event Suggestion / Message</label>
              <textarea id="message" name="message" value={formData.message} onChange={handleChange} rows="5" required></textarea>
            </div>
            <div className="contact-footer">
              <button type="submit" className="contact-submit-btn" disabled={status === 'sending'}>
                {status === 'sending' ? 'Sending...' : 'Send Message'}
              </button>
            </div>
          </form>
        )}

        {status === 'success' && (
          <div className="contact-success-message">
            <h3>Thank You!</h3>
            <p>Your message has been sent. We appreciate your feedback.</p>
            <button onClick={onClose} className="contact-submit-btn">Close</button>
          </div>
        )}

        {status === 'error' && (
          <p className="contact-error-message">{errorMessage}</p>
        )}
      </div>
    </div>
  );
};

export default ContactModal;